import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: '',
    availableFutureDates: [],
    noPricesMessage: '',
};

export const getAvailableFutureDates = createAsyncThunk(
    'no-available-prices/getAvailableFutureDates',
    async (url) => {
        const response = await axios.get(url);

        return response.data;
    }
);

export const noAvailablePricesSlice = createSlice({
    name: 'noAvailablePrices',
    initialState,
    extraReducers: (builder) => {
        builder.addCase(getAvailableFutureDates.pending, (state) => {
            state.isFetching = true;
            state.isSuccess = false;
            state.isError = false;
            state.errorMessage = '';
            state.availableFutureDates = [];
        });
        builder.addCase(
            getAvailableFutureDates.fulfilled,
            (state, { payload }) => {
                state.isFetching = false;
                state.isSuccess = true;
                state.isError = false;
                state.errorMessage = '';
                state.availableFutureDates = payload?.futureDateList;
                state.noPricesMessage = payload?.noPricesMessage;
            }
        );
        builder.addCase(getAvailableFutureDates.rejected, (state) => {
            state.isFetching = false;
            state.isSuccess = false;
            state.isError = false;
            state.errorMessage = '';
            state.availableFutureDates = [];
        });
    },
});
